import { Provider } from '@angular/core';

import { PublicationRepositoryImpl } from '@app/data/repositories/multimedia/publication/publication.repository';
import { PUBLICATION_REPOSITORY } from '@app/domain/repositories/multimedia/publication/publication.repository.contract';

export const publicationRepositoryProvider: Provider = {
  provide: PUBLICATION_REPOSITORY,
  useClass: PublicationRepositoryImpl
};
